import React, { useEffect, useState } from 'react';
import './LoadingScreen.css';

const LoadingScreen = () => {
  const [phase, setPhase] = useState('presence'); // presence -> handoff -> complete

  useEffect(() => {
    // Preload images
    const preloadImages = () => {
      const images = [
        '/assets/images/LandingAndBackgroundLogo.png',
        '/assets/images/TopCornerLogo.png'
      ];
      images.forEach(src => {
        const img = new Image();
        img.src = src;
      });
    };
    preloadImages();

    // Phase transitions
    const presenceTimer = setTimeout(() => {
      setPhase('handoff');
    }, 2000);

    return () => clearTimeout(presenceTimer);
  }, []);

  return (
    <div className={`loading-screen phase-${phase}`}>
      <div className="ripple-container">
        <div className="ripple ripple-1"></div>
        <div className="ripple ripple-2"></div>
        <div className="ripple ripple-3"></div>
      </div>
      
      <div className="splash-logo-container">
        <img 
          src="/assets/images/LandingAndBackgroundLogo.png" 
          alt="Gentrobyte AI Labs"
          className="splash-logo"
        />
      </div>
    </div>
  );
};

export default LoadingScreen;
